import { useState } from 'react'
import { AxiosUserRepository } from '../../infrastructure/AxiosUserRepository'
import { UpdateUserUseCase } from '../../usecases/UpdateUserUseCase'
import type { User } from '../../domain/user'

export function useUserUpdate() {
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState<Error | null>(null)

    const updateUser = async (
        userId: number,
        data: Partial<Omit<User, 'id'>>
    ): Promise<User | null> => {
        setIsLoading(true)
        setError(null)

        try {
            const repository = new AxiosUserRepository()
            const updateUserUseCase = new UpdateUserUseCase(repository)
            const updatedUser = await updateUserUseCase.execute(userId, data)
            return updatedUser
        } catch (err) {
            const error =
                err instanceof Error ? err : new Error('Failed to update user')
            setError(error)
            return null
        } finally {
            setIsLoading(false)
        }
    }

    return {
        updateUser,
        isLoading,
        error,
    }
}
